import immer, { setAutoFreeze } from 'immer'
import _ from 'lodash'

import { isEqualWithType } from './index'
setAutoFreeze(false)

export const matchListItem = (listName, str) => {
	return str.match(`^(?<name>${_.escapeRegExp(listName)})\\[(?<id>[_-\\d]+)\\]\\.(?<field>.+)$`)
}
const matchListHead = listName => listName.match(/(?<name>[^\[]+)\[(?<id>(?:_|-|\d)+)\].(?<field>.+)/)

const genNestChangeInfo = listName => {
	let m = matchListHead(listName)
	if (!m) return null
	const { name, id, field } = m.groups
	const ret = {
		newListName: name,
		newIdPar: id,
		newItemNamePre: field,
		newListItemChangedValuesPar: {}
	}
	// let namePre = ''
	// while (m = matchListHead(m.groups.field)) {
	// 	ret.newListItemChangedValuesPar[`${namePre}${m[1]}-changed`] = [parseInt(m[2])]
	// 	namePre = `${namePre}${m[1]}[${parseInt(m[2])}].`
	// }
	return ret
}
// console.log('newNestChangeInfo for test[1].debug[2].field:', genNestChangeInfo('test[1].debug[2].field'))
// const markListInTypesOfChanged = (that, fieldsetName, listName) => {

//   that.setState(immer(draft => {
//     const changedValues = draft[`changedValues${fieldsetName}`] || {}
//     const idArr = [...(changedValues[`${listName}-added`] || []), ...(changedValues[`${listName}-changed`] || []), ...(changedValues[`${listName}-deleted`] || [])]
//     const typesOfchangedValues = draft[`typesOfchangedValues${fieldsetName}`] = draft[`typesOfchangedValues${fieldsetName}`] || {}
//     const listMarks = typesOfchangedValues['__list'] = typesOfchangedValues['__list'] || []

//     idArr.length && !listMarks.includes(listName) && listMarks.push(listName)
//     !idArr.length && listMarks.includes(listName) && listMarks.splice(listMarks.indexOf(listName), 1)

//     // console.log('idArr, listMarks', idArr, listMarks)
//   }))
//   // console.log('check typesofchanged:', fieldsetName, listName)
// }
export const changeListItemAsync = (...args) => {
	return Promise.resolve().then(() => {
		changeListItem(args)
		return
	})
}

export const changeListItem = (that, listItemChangedValuesPar, listItemTypesOfChangedValues = {}, fieldsetName = '', listName, itemIdPar, sortField) => {
	listItemTypesOfChangedValues = listItemTypesOfChangedValues || {}
	that && that.setState(immer((draft, props) => {
		const initValues = { ...props[`initValues${fieldsetName}`], ...draft[`initValues${fieldsetName}`] }
		const changedValues = draft[`changedValues${fieldsetName}`] = draft[`changedValues${fieldsetName}`] || {}
		doChangeListItem(initValues, changedValues, listItemChangedValuesPar, listItemTypesOfChangedValues, listName, itemIdPar, sortField)
	}))
}

const doChangeListItem = (initValues, changedValues, listItemChangedValuesPar, listItemTypesOfChangedValues = {}, listName, itemIdPar, sortField) => {
	listItemTypesOfChangedValues = listItemTypesOfChangedValues || {}
	/**
	 * 处理所有sub list,
	 * 1、生成sub list结构
	 * 2、递归合并sub list数据
	 * @param {*} initValues 
	 * @param {*} changedValues 
	 * @param {*} listItemChangedValues 
	 * @param {*} listName 
	 * @param {*} itemId 
	 */
	const treatNestedList = (initValues, changedValues, listItemChangedValues, listName, itemId) => {
		/**
		 * 生成sub list 结构
		 */
		const genListsStruct = (listItemChangedValues) => {
			const objRet = {}
			let m // 临时变量
			listItemChangedValues && Object.keys(listItemChangedValues).forEach(key => {
				if (key.endsWith('-added') || key.endsWith('-deleted') || key.endsWith('-changed')) {
					let subObj = objRet
					let subKey = key
					while (m = matchListHead(subKey)) {
						const { name, id, field } = m.groups
						subObj = subObj[name] || (subObj[name] = {})
						subObj = subObj[id] || (subObj[id] = {})
						subKey = field
					}
					subKey = subKey.substring(0, subKey.lastIndexOf('-'))
					!subObj[subKey] && (subObj[subKey] = {})
				}
			})
			return objRet
		}


		/**
		 * 递归合并sub list数据
		 * @param {*} listsStruct 
		 * @param {*} valuePre 
		 * @param {*} listPre 
		 */

		const mergeNestedList = (listsStruct, valuePre, listPre) => {
			let m		// 匹配结果临时变量，以便反复生成新变量

			Object.keys(listsStruct).forEach(listName => {
				// 准备数据
				const valueItemName = `${valuePre}${listName}`
				const listItemName = `${listPre}${listName}`
				const { [valueItemName]: init = [] } = initValues || {}
				const changedAdded = changedValues[`${valueItemName}-added`] = changedValues[`${valueItemName}-added`] || []
				const changedDeleted = changedValues[`${valueItemName}-deleted`] = changedValues[`${valueItemName}-deleted`] || []
				const changedChanged = changedValues[`${valueItemName}-changed`] = changedValues[`${valueItemName}-changed`] || []
				const {
					[`${listItemName}-added`]: listAdded = [],
					[`${listItemName}-deleted`]: listDeleted = [],
					[`${listItemName}-changed`]: listChanged = []
				} = listItemChangedValues || {}
				const listAll = [...listAdded, ...listDeleted, ...listChanged]
				// 处理子项
				Object.keys(listsStruct[listName]).forEach(id => {
					// id = parseInt(id)
					const valuePreNext = `${valuePre}${listName}[${id}].`
					const listPreNext = `${listPre}${listName}[${id}].`
					mergeNestedList(listsStruct[listName][id], valuePreNext, listPreNext)
					// 检查changedValues有没有以valuePreNext开头的数据
					if (listAll.findIndex(o => o == id) > -1)
						return
					!!Object.keys(changedValues).find(name => name.startsWith(valuePreNext))
						? changedChanged.findIndex(o => o == id) === -1 && changedChanged.push(id)
						: changedChanged.findIndex(o => o == id) > -1 && changedChanged.splice(changedChanged.findIndex(o => o == id), 1)
				})
				// 处理当前list
				// 处理deleted: 从changedAdded、changedChanged、listAdded、listChanged、中删除id，并从changedValues，listItemChangedValues中删除数据，如果存在于init中，在changedDeleted中增加id
				listDeleted.forEach(id => {
					changedAdded.findIndex(o => o == id) > -1 && changedAdded.splice(changedAdded.findIndex(o => o == id), 1)
					changedChanged.findIndex(o => o == id) > -1 && changedChanged.splice(changedChanged.findIndex(o => o == id), 1)
					listAdded.findIndex(o => o == id) > -1 && listAdded.splice(listAdded.findIndex(o => o == id), 1)
					listChanged.findIndex(o => o == id) > -1 && listChanged.splice(listChanged.findIndex(o => o == id), 1)

					init.findIndex(o => o == id) > -1 && changedDeleted.findIndex(o => o == id) === -1 && changedDeleted.push(id)

					Object.keys(listItemChangedValues).forEach(o => {
						true && (m = matchListItem(listItemName, o)) && m.groups.id == id && delete listItemChangedValues[o]
					})

					Object.keys(changedValues).forEach(o => {
						true && (m = matchListItem(valueItemName, o)) && m.groups.id == id && delete changedValues[o]
					})
				})
				delete listItemChangedValues[`${listItemName}-deleted`]

				// 处理added:
				// 1、检查id是否大于0
				// 1.1、如果大于0，表示是数据库中已有记录，
				// 1.1.1、检查changedDeleted是否存在该id
				// 1.1.1.1、如有则从changedDeleted中删除id，将id加入到listChanged中待后续处理，结束
				// 1.1.1.2、如没有，置newId = id
				// 1.2、如果小于0，表示是新增数据，检查id是否小于原有最小id，
				// 1.2.1是则置minId为当前id,置newId = id
				// 1.2.2否则生成新的newId为--minId
				// 1.3 以newId剪切数据到changedValues中，并在changedAdded中增加newId 
				// 以下为旧备注，留置待查
				// 检查是否存在于changedDeleted中，如果是则生成新的id并复制changedValues中所有已有值(旧id->新id)，
				// 复制所有新数据到changedValues中，删除listItemChangedValues中数据
				let minId = Math.min(
					0,
					...[...init, ...changedAdded, ...changedDeleted, ...changedChanged, /* ...listAdded,  */...listChanged, ...listDeleted]
						.map(o => parseInt(o) == o ? o : 0)
				)

				listAdded.forEach(id => {
					let newId = id

					if (id > 0) {
						if (changedDeleted.findIndex(o => o == id) > -1) {
							changedDeleted.splice(changedDeleted.findIndex(o => o == id), 1)
							listChanged.push(id)
							return
						}
					} else {
						newId >= minId ? (newId = (--minId)) : (minId = id)
					}

					changedAdded.push(newId)

					Object.entries(listItemChangedValues).forEach(([name, value]) => {
						if (!(m = matchListItem(listItemName, name)) || m.groups.id != id)
							return
						changedValues[`${valueItemName}[${newId}].${m.groups.field}`] = value
						delete listItemChangedValues[name]
					})
				})
				delete listItemChangedValues[`${listItemName}-added`]

				// 处理changed: 检查每项值与initValues中值是否一致，是则从changedValues中删除该值，否则复制；从listItemChangedValues中删除该值 ；最后检查是否还有变动，如果没有从changedChanged中去除id
				listChanged.forEach(id => {
					Object.entries(listItemChangedValues).forEach(([name, value]) => {
						if (!(m = matchListItem(listItemName, name)) || m.groups.id != id)
							return
						const fullName = `${valueItemName}[${id}].${m.groups.field}`
						!isEqualWithType(initValues[fullName], value, listItemTypesOfChangedValues[name] || 'string')
							// 20050327 类型为'array'时将空值置为[]
							? (changedValues[fullName] = listItemTypesOfChangedValues[name] == 'array' ? value || [] : value)
							: delete changedValues[fullName]
						delete listItemChangedValues[name]
					})

					// 如果是一个新增数据，则去除changed
					if (changedAdded.findIndex(o => o == id) > -1)
						changedChanged.findIndex(o => o == id) > -1 && changedChanged.splice(changedChanged.findIndex(o => o == id), 1)
					else {
						const namePre = `${valueItemName}[${id}].`
						const bChanged = !!Object.keys(changedValues).find(name => name.startsWith(namePre))
						// const bChanged = Object.keys(changedValues).find(o => (m = matchListItem(valueItemName, o)) && parseInt(m[2]) === id) && true || false

						bChanged
							? changedChanged.findIndex(o => o == id) === -1 && changedChanged.push(id)
							: changedChanged.findIndex(o => o == id) > -1 && changedChanged.splice(changedChanged.findIndex(o => o == id), 1)
					}
				})
				delete listItemChangedValues[`${listItemName}-changed`]
				// 从changedValues中删除空的changed, added, deleted
				changedDeleted.length ? changedDeleted.sort() : delete changedValues[`${valueItemName}-deleted`]
				changedAdded.length ? changedAdded.sort() : delete changedValues[`${valueItemName}-added`]
				changedChanged.length ? changedChanged.sort() : delete changedValues[`${valueItemName}-changed`]
			})
		}


		const listsStruct = genListsStruct(listItemChangedValues)
		// console.log('listsStruct:', listsStruct)
		if (!Object.keys(listsStruct).length)
			return

		const valuePre = `${listName}[${itemId}].`
		const listPre = ''

		mergeNestedList(listsStruct, valuePre, listPre)
	}

	const dealSortField = (sortField, itemIdArr, listItemChangedValuesArr) => {
		if (sortField) {
			listItemChangedValuesArr = _.cloneDeep(listItemChangedValuesArr)
			// 1、将itemIdArr中id写入listItemChangedValuesArr；根据sortField排序listItemChangedValuesArr；重新生成itemIdArr；
			//    生成listItemChangedValuesMap对象, 删除listItemChangedValuesArr中的id；
			itemIdArr.forEach((id, index) => listItemChangedValuesArr[index].id = id)
			listItemChangedValuesArr = _.sortBy(listItemChangedValuesArr, sortField)
			itemIdArr = listItemChangedValuesArr.map(o => o.id)
			const listItemChangedValuesMap = {}
			listItemChangedValuesArr.forEach(o => { listItemChangedValuesMap[o.id] = o; delete o.id })
			// 2、读取已排序的{list, map}
			const { list, map } = getListFromValues(listName, initValues, changedValues, [], sortField)
			// 3、逐个处理listItemChangedValuesArr，在list中将原记录置入相应的位置
			listItemChangedValuesArr.forEach((o, index) => {
				let { [sortField]: sortValue } = o
				if (!sortValue) return
				sortValue = sortValue > 0 ? sortValue : 1
				const value = map[itemIdArr[index]]
				if (!value) return
				const listIndex = list.indexOf(value)
				if (sortValue == listIndex + 1) return
				list.splice(listIndex, 1)
				list.splice(sortValue - 1, 0, value)
			})
			// 4、逐个处理list中的数据，如果对象中的排序值与当前序号+1不一致则(如果id在listItemChangedValuesMap中则修改listItemChangedValuesArr中相应值，否则新增一条修改数据)，
			//    否则(如果id在listItemChangedValuesMpa中则删除数据中的[sortField])
			list.forEach((o, index) => {
				o[sortField] !== index + 1
					? listItemChangedValuesMap[o.id]
						? (listItemChangedValuesMap[o.id][sortField] = index + 1)
						: (listItemChangedValuesArr.push({ [sortField]: index + 1 }), itemIdArr.push(o.id))
					: listItemChangedValuesMap[o.id] ? delete listItemChangedValuesMap[o.id][sortField] : undefined
			})
		}
		return { itemIdArr, listItemChangedValuesArr }
	}

	if ((Array.isArray(listItemChangedValuesPar) && !Array.isArray(itemIdPar)) || (!Array.isArray(listItemChangedValuesPar) && Array.isArray(itemIdPar))) {
		console.error('changeListItem params id and changedValues not martch!', listItemChangedValuesPar, itemIdPar)
		return
	}


	// console.log('listName:', listName)
	// console.log('itemIdArr:', itemIdArr)
	// console.log('listItemChangedValuesArr:', listItemChangedValuesArr)

	// 处理sortField
	const { itemIdArr, listItemChangedValuesArr } = dealSortField(sortField,
		Array.isArray(itemIdPar) ? itemIdPar : [itemIdPar],
		Array.isArray(listItemChangedValuesPar) ? listItemChangedValuesPar : [listItemChangedValuesPar]
	)

	// 如果listName是list子集
	const nestInfo = genNestChangeInfo(listName)
	if (nestInfo) {
		const { newListName, newIdPar, newItemNamePre, newListItemChangedValuesPar } = nestInfo
		const newListItemTypesOfChangedValues = {}

		newListItemChangedValuesPar[`${newItemNamePre}-changed`] = [].concat(itemIdArr)
		itemIdArr.forEach((itemId, index) => {
			Object.entries(listItemChangedValuesArr[index]).forEach(([name, value]) => newListItemChangedValuesPar[`${newItemNamePre}[${itemId}].${name}`] = value)
			Object.entries(listItemTypesOfChangedValues).forEach((name, type) => newListItemTypesOfChangedValues[`${newItemNamePre}[${itemId}].${name}`] = type)
		})
		// console.log('changedValues:', newListItemChangedValuesPar, fieldsetName, newListName, newIdPar)
		return doChangeListItem(initValues, changedValues, newListItemChangedValuesPar, newListItemTypesOfChangedValues, newListName, newIdPar)
	}

	const addedValue = changedValues[`${listName}-added`] || []
	const changedValue = changedValues[`${listName}-changed`] = changedValues[`${listName}-changed`] || []

	itemIdArr.forEach((itemId, index) => {
		const listItemChangedValues = _.cloneDeep(listItemChangedValuesArr[index] || {})

		// console.log('initValues:', _.cloneDeep(initValues))
		// console.log('changedValues before merged:', _.cloneDeep(changedValues))
		// console.log('listItemChangedValues before merged:', _.cloneDeep(listItemChangedValues))

		treatNestedList(initValues, changedValues, listItemChangedValues, listName, itemId)

		Object.entries(listItemChangedValues).forEach(([name, value]) => {
			const fullName = (listName !== undefined && itemId !== undefined) ? `${listName}[${itemId}].${name}` : name
			!isEqualWithType(initValues[fullName], value, listItemTypesOfChangedValues[name] || 'string')
				// 20050327 类型为'array'时将空值置为[]
				? (changedValues[fullName] = listItemTypesOfChangedValues[name] == 'array' ? value || [] : value)
				: delete changedValues[fullName]
		})

		if (addedValue.findIndex(o => o == itemId) > -1)
			changedValue.findIndex(o => o == itemId) > -1 && changedValue.splice(changedValue.findIndex(o => o == itemId), 1)
		else {
			const namePre = `${listName}[${itemId}].`
			const bChanged = !!Object.keys(changedValues).find(name => name.startsWith(namePre))

			bChanged
				? changedValue.findIndex(o => o == itemId) === -1 && changedValue.push(itemId)
				: changedValue.findIndex(o => o == itemId) > -1 && changedValue.splice(changedValue.findIndex(o => o == itemId), 1)
		}

		// console.log('changedValues after merged:', _.cloneDeep(changedValues))
		// console.log('listItemChangedValues after merged:', _.cloneDeep(listItemChangedValues))
	})

	changedValue.length ? changedValue.sort() : (delete changedValues[`${listName}-changed`])
}

export const addListItemAsync = (...args) => {
	return Promise.resolve().then(() => {
		addListItem(args)
		return
	})
}

/**
 * 同时新增多个List记录
 * @param {*} that 
 * @param {Array} listItemChangedValuesArr 
 * @param {String} fieldsetName 
 * @param {String} listName 
 */
export const addListItems = (that, listItemChangedValuesArr, fieldsetName = '', listName, sortField) => {
	that && that.setState(immer((draft, props) => {
		const initValues = { ...props[`initValues${fieldsetName}`], ...draft[`initValues${fieldsetName}`] }
		const changedValues = draft[`changedValues${fieldsetName}`] = draft[`changedValues${fieldsetName}`] || {}
		listItemChangedValuesArr.forEach(listItemChangedValues => {
			doAddListItem(initValues, changedValues, listItemChangedValues, listName, listItemChangedValues.id, sortField)
		})
	}))
}

/**
 * 如果带入id且id > 0, 则需要处理看是否存在已有数据(listItem, listItem-added, listItem-changed, listItem-deleted)
 * @param {*} that 
 * @param {*} listItemchangedValues 
 * @param {*} fieldsetName 
 * @param {*} listName 
 * @param {*} id 
 */
export const addListItem = (that, listItemchangedValues, fieldsetName = '', listName, id, sortField) => {
	that && that.setState(immer((draft, props) => {
		const initValues = { ...props[`initValues${fieldsetName}`], ...draft[`initValues${fieldsetName}`] }
		const changedValues = draft[`changedValues${fieldsetName}`] = draft[`changedValues${fieldsetName}`] || {}
		doAddListItem(initValues, changedValues, listItemchangedValues, listName, id, sortField)
	}))
}

const doAddListItem = (initValues, changedValues, listItemchangedValues, listName, id, sortField) => {
	// 如果带入的id不大于0则置为undefined
	// !!! TODO: 目前临时保留负id使用，主要针对checkGrid选择使用负id与实际关联表的id区分开来，后续提供方案解决
	// id = id > 0 ? id : undefined

	// 如果有sortField，取当前所有数据，在listItemchangedValues中置入sortField
	if (sortField) {
		const { list } = getListFromValues(listName, initValues, changedValues, [], sortField)
		listItemchangedValues[sortField] = list.length ? (list[list.length - 1][sortField] || 0) + 1 : 1
	}

	// 如果listName是list子集
	const nestInfo = genNestChangeInfo(listName)
	if (nestInfo) {
		const { newListName, newIdPar, newItemNamePre, newListItemChangedValuesPar } = nestInfo
		const itemId = id || -1
		newListItemChangedValuesPar[`${newItemNamePre}-added`] = [itemId]
		Object.entries(listItemchangedValues).forEach(([name, value]) => newListItemChangedValuesPar[`${newItemNamePre}[${itemId}].${name}`] = value)
		doChangeListItem(initValues, changedValues, newListItemChangedValuesPar, undefined, newListName, newIdPar)
		return
	}

	const { [`${listName}`]: init = [] } = initValues

	// id > 0(!!!临时修改为判断有值），如果在init或-added中存在，则调用修改
	// if (id > 0 && (init.concat(changedValues[`${listName}-added`] || []).includes(id))) {
	if (id && (init.concat(changedValues[`${listName}-added`] || []).findIndex(o => o == id) > -1)) {
		// 如果id在init中并检查是否在deleted中，如是，则从deleted中删除
		const deleted = changedValues[`${listName}-deleted`] || []
		init.findIndex(o => o == id) > -1 && deleted.findIndex(o => o == id) > -1
			&& (deleted.length === 1 ? delete changedValues[`${listName}-deleted`] : changedValues[`${listName}-deleted`] = deleted.filter(o => o != id))

		doChangeListItem(initValues, changedValues, listItemchangedValues, undefined, listName, id)
		return
	}

	const added = changedValues[`${listName}-added`] = changedValues[`${listName}-added`] || []
	const newId = id || (Math.min(0, ...[...init, ...added].map(o => parseInt(o) == o ? o : 0)) - 1)
	added.push(newId)
	// added.sort()
	const preName = listName == undefined ? '' : `${listName}[${newId}].`
	changedValues[`${preName}id`] = newId
	Object.entries(listItemchangedValues).forEach(([name, value]) => changedValues[`${preName}${name}`] = value)
}

/**
 * 
 * @param {*} that 
 * @param {*} fieldsetName 
 * @param {*} listName 
 * @param {*} Ids 
 * @param {*} values 
 */
export const setListItems = (that, fieldsetName = '', listName, Ids, values) => {
	that && that.setState(immer((draft, props) => {
		const initValues = { ...props[`initValues${fieldsetName}`], ...draft[`initValues${fieldsetName}`] }
		const changedValues = draft[`changedValues${fieldsetName}`] = draft[`changedValues${fieldsetName}`] || {}
		const oldIds = getListIdsFromValues(listName, initValues, changedValues)
		oldIds.length && doDeleteListItem(initValues, changedValues, listName, oldIds)
		Ids.forEach((id, index) => doAddListItem(initValues, changedValues, values[index], listName, id))
	}))
}

/**
 * 从srcChangedValues里添加srcChangedVaues所有srcListName||listName条目到fieldsetName=>[listName]-added中, 新id为负
 * 主要用于checkGrid（对话框中含）所生成的数据复制到目标数据中并形成新的id
 * @param {Object} that 
 * @param {String} fieldsetName 
 * @param {String} listName 
 * @param {String} srcChangedValues 
 * @param {String?} idField		// 老id在新数据中的对应外联字段，
 * @param {String?} srcListName 
 */
export const addNewListItemsFromListItems = (that, fieldsetName = '', listName, srcChangedValues, idField, srcListName) => {
	const { list: changedList } = getListFromValues(srcListName || listName, null, {}, srcChangedValues)
	changedList.forEach(o => (idField && (o[idField] = o.id), delete o.id))
	addListItems(that, changedList, fieldsetName, listName)
}

export const addListItemsFromListItemsAsync = (...args) => {
	return Promise.resolve().then(() => {
		addListItemsFromListItems(args)
		return
	})
}

/**
 * 从srcChangedValues里复制srcChangedVaues[`${srcListName||listName}-added`]所有条目到fieldsetName中, id不变，忽略重复数据
 * 主要用于checkGrid（对话框中含）所生成的数据复制到目标数据中
 * todo: 1、如果listName
 * 
 * @param {*} that 
 * @param {*} fieldsetName 
 * @param {*} listName 
 * @param {*} srcChangedValues 
 * @param {*} srcListName 
 */
export const addListItemsFromListItems = (that, fieldsetName = '', listName, srcChangedValues, srcListName) => {
	!srcListName && (srcListName = listName)

	that && that.setState(immer(draft => {
		const { [`initValues${fieldsetName}`]: { [listName]: value = [] } = {} } = draft
		const changedValues = draft[`changedValues${fieldsetName}`] || (draft[`changedValues${fieldsetName}`] = {})
		const addIds = changedValues[`${listName}-added`] || (changedValues[`${listName}-added`] = [])
		const deletedIds = changedValues[`${listName}-deleted`] || (changedValues[`${listName}-deleted`] = [])

		const { [`${srcListName}-added`]: newIds = [] } = srcChangedValues

		newIds.forEach(id => {
			if (deletedIds.findIndex(o => o == id) > -1) {
				deletedIds.splice(deletedIds.findIndex(o => o == id), 1)
				return
			}

			if (value.findIndex(o => o == id) > -1 || addIds.findIndex(o => o == id) > -1)
				return

			addIds.findIndex(o => o == id) === -1 && addIds.push(id)
			copyListValuesById(listName, srcChangedValues, changedValues, id, srcListName)
		})

		!addIds.length && delete changedValues[`${listName}-added`]
		!deletedIds.length && delete changedValues[`${listName}-deleted`]
	}))
}

export const deleteListItemAsync = (...args) => {
	return Promise.resolve().then(() => {
		deleteListItem(args)
		return
	})
}

export const deleteListItem = (that, fieldsetName = '', listName, itemIdPar) => {
	that && that.setState(immer((draft, props) => {
		const initValues = { ...props[`initValues${fieldsetName}`], ...draft[`initValues${fieldsetName}`] }
		const changedValues = draft[`changedValues${fieldsetName}`] = draft[`changedValues${fieldsetName}`] || {}
		doDeleteListItem(initValues, changedValues, listName, itemIdPar)
	}))
}

const doDeleteListItem = (initValues, changedValues, listName, itemIdPar) => {
	const nestInfo = genNestChangeInfo(listName)
	if (nestInfo) {
		const { newListName, newIdPar, newItemNamePre, newListItemChangedValuesPar } = nestInfo
		const itemId = -1
		newListItemChangedValuesPar[`${newItemNamePre}-deleted`] = [].concat(itemIdPar)
		doChangeListItem(initValues, changedValues, newListItemChangedValuesPar, undefined, newListName, newIdPar)
		return
	}

	const { [`${listName}`]: initValue = [] } = initValues

	const deleted = changedValues[`${listName}-deleted`] = changedValues[`${listName}-deleted`] || []
	const added = changedValues[`${listName}-added`] = changedValues[`${listName}-added`] || []
	const changed = changedValues[`${listName}-changed`] = changedValues[`${listName}-changed`] || []

	const items = Array.isArray(itemIdPar) ? itemIdPar : [itemIdPar]

	items.forEach(itemId => {
		changed.findIndex(o => o == itemId) > -1 && changed.splice(changed.findIndex(o => o == itemId), 1)
		deleteListValuesById(changedValues, listName, itemId)

		if (initValue.findIndex(o => o == itemId) > -1) {   // 在初始数据中存在
			deleted.findIndex(o => o == itemId) === -1 && deleted.push(itemId)
		} else {      // 还未写入数据库的，临时保存在前端的
			added.findIndex(o => o == itemId) > -1 && added.splice(added.findIndex(o => o == itemId), 1)
		}
	})

	deleted.sort()

	!deleted.length && (delete changedValues[`${listName}-deleted`])
	!added.length && (delete changedValues[`${listName}-added`])
	!changed.length && (delete changedValues[`${listName}-changed`])
}

const deleteListValuesById = (values, listName, itemId) => {
	let m
	Object.keys(values).forEach(o => {
		true && (m = matchListItem(listName, o)) && m.groups.id == itemId && delete values[o]
	})
}


/**
 * @return {list, map}
 * @param {String} listName
 * @param {Object} initValues 
 * @param {Object} changedValues 
 * @param {Array} ignore
 * @param {String} sortField
 */
export const getListFromValues = (listName, value, initValues, changedValues, ignore = [], sortField) => {
	// value参数不再使用，为保证原有调用保留；如果value有值且不是数组，则视为无value参数
	value && !Array.isArray(value)
		? (sortField = ignore, ignore = changedValues || [], changedValues = initValues || {}, initValues = value)
		: (changedValues = changedValues || {})
	const currentValues = { ...initValues, ...changedValues }
	const map = {}
	value = /* value ||  */currentValues[listName] || []
	const {
		[`${listName}-added`]: added = [],
		[`${listName}-deleted`]: deleted = []
	} = changedValues


	const curr = [...value, ...added]

	// 根据changedValues中所有以listName开头并以-added,-deleted结束的数据，并在相对应的数组字段中增加-added中数据并删除-deleted中数据，注意：以免影响原始数据，需要生成新数组而不要修改原始数组
	Object.keys(changedValues).forEach(key => {
		if (!key.startsWith(listName))
			return

		if (key.endsWith('-added') && key !== `${listName}-added`) {
			const valueKey = key.substring(0, key.length - 6)
			const newValue = [...(currentValues[valueKey] || []), ...(currentValues[key] || [])]
			newValue.length && (currentValues[valueKey] = newValue)
			return
		}

		if (key.endsWith('-deleted') && key !== `${listName}-deleted`) {
			const valueKey = key.substring(0, key.length - 8)
			const deleted = currentValues[key] || []
			const newValue = (currentValues[valueKey] || []).filter(o => deleted.findIndex(id => id == o) === -1)
			newValue.length && (currentValues[valueKey] = newValue)
			!newValue.length && delete currentValues[valueKey]

			// 删除deleted数据
			Object.keys(currentValues).forEach(o => {
				const m = matchListItem(valueKey, o)
				m && deleted.findIndex(o => o == m.groups.id) > -1 && delete currentValues[o]
			})

			return
		}
	})

	let list = []
	ignore = ignore.concat(deleted)
	curr && curr.filter(o => ignore.findIndex(id => id == o) === -1).forEach(id => {
		// if (isNaN(parseInt(id))) {
		// 	console.error(`list '${listName}' has invalid value(not int):`, id)
		// 	return
		// }
		if (map[id]) {
			console.error(`list '${listName}' has duplicated value:`, id)
			return
		}
		map[id] = { id }
		list.push(map[id])
	})

	// 去除currentValues中所有不以listName开头或以-added,-deleted,-changed结束的数据 ???
	list.length > 0 && Object.keys(currentValues).forEach(o => {
		const m = matchListItem(listName, o)
		if (!m) return
		const { name, id, field } = m.groups
		if (name === listName && map[id] !== undefined && !o.endsWith('-added') && !o.endsWith('-changed') && !o.endsWith('-deleted')) {
			map[id][field] = currentValues[o]
		}
	})

	// 排序 
	sortField && (list = _.sortBy(list, sortField))

	return { list, map }
}


export const getMixedListValues = (listName, initValues = {}, changedValues = {}, includeDeleted = false) => {
	const values = { ...initValues, ...changedValues }
	const value = initValues[listName] || []
	const { [`${listName}-added`]: added = [], [`${listName}-deleted`]: deleted = [] } = changedValues
	const curr = includeDeleted ? [...value, ...added] : ([...value, ...added].filter(id => deleted.findIndex(o => o == id) === -1))

	delete values[`${listName}-added`]
	delete values[`${listName}-deleted`]

	values[listName] = curr

	return values
}

export const copyListValuesById = (listName, src, dest, id, srcListName) => {
	!srcListName && (srcListName = listName)

	const namePrex = `${listName}[${id}]`
	const srcNamePrex = `${srcListName}[${id}]`
	const lenSrcNamePrex = srcNamePrex.length

	Object.keys(src).forEach(o => o.startsWith(srcNamePrex) && (dest[`${namePrex}${o.slice(lenSrcNamePrex)}`] = src[o]))
}


/**
 * 取指定list的id数组
 * @param {*} that 
 * @param {String} fieldsetName 
 * @param {String} fieldName 
 * @param {[Int]} ignore
 */
export const getListIds = (that, fieldsetName = '', fieldName, ignore = []) => getListIdsFromValues(fieldName,
	{ ...(that.props[`initValues${fieldsetName}`] || {}), ...(that.state[`initValues${fieldsetName}`] || {}) },
	that.state[`changedValues${fieldsetName}`],
	ignore
)

/**
 * 从initValues, changedValues中取指定的fieldName的id数组
 * @param {String} fieldName 
 * @param {*} initValues 
 * @param {*} changedValues 
 * @param {[Int]} ignore 
 */
export const getListIdsFromValues = (fieldName, initValues, changedValues = {}, ignore = []) => {
	ignore = ignore.concat(changedValues[`${fieldName}-deleted`] || [])
	// const deleted = (that.state[`changedValues${fieldsetName}`] || {})[`${fieldName}-deleted`] || []
	const ids = []
		.concat(initValues[fieldName] || [])
		.concat(changedValues[`${fieldName}-added`] || []).filter(id => ignore.findIndex(o => o == id) === -1)
	return ids

}
/**
 * @return {list, map}
 * @param {Object} that 
 * @param {String} fieldsetName 
 * @param {String} fieldName 
 * @param {Array} ignore
 * @param {String} sortField
 */
export const getListItems = (that, fieldsetName = '', fieldName, ignore = [], sortField) => {
	if (!that)
		return {}

	const initValues = { ...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`] }
	const changedValues = that.state[`changedValues${fieldsetName}`] || {}
	// const { [`${fieldName}`]: value = [] } = initValues

	return getListFromValues(fieldName, null, initValues, changedValues, ignore, sortField)
}

// 读取list数据条数
export const getListCount = (that, fieldsetName = '', fieldName, ignore = []) => {
	if (!that)
		return -1

	const initValues = { ...that.props[`initValues${fieldsetName}`], ...that.state[`initValues${fieldsetName}`] }
	const changedValues = that.state[`changedValues${fieldsetName}`] || {}

	const value = initValues[fieldName] || []
	const { [`${fieldName}-added`]: added = [], [`${fieldName}-deleted`]: deleted = [] } = changedValues
	ignore = ignore.concat(deleted)
	const curr = [...value, ...added].filter(id => ignore.findIndex(o => o == id) == -1)

	return curr.length
}


export const resetListValuesAsync = (...args) => {
	return Promise.resolve().then(() => {
		resetListValues(args)
		return
	})
}

/**
 * 重置listValues，即从changedValues删除新增、修改、删除信息
 * @param {*} that 
 * @param {*} fieldsetName 
 * @param {*} listName 
 */
export const resetListValues = (that, fieldsetName = '', listName) => {
	that && that.setState(immer(draft => {
		const changedValues = draft[`changedValues${fieldsetName}`] || (draft[`changedValues${fieldsetName}`] = {})
		const { [`${listName}-added`]: added = [], [`${listName}-deleted`]: deleted = [], [`${listName}-changed`]: changed = [] }
			= changedValues

		const idArr = [...added, ...deleted, ...changed]
		idArr.forEach(id => deleteListValuesById(changedValues, listName, id))

		delete changedValues[`${listName}-added`]
		delete changedValues[`${listName}-changed`]
		delete changedValues[`${listName}-deleted`]
	}))
}

export const isListValuesChanged = (that, fieldsetName = '', listName) => {
	const { [`${listName}-added`]: added = [], [`${listName}-deleted`]: deleted = [], [`${listName}-changed`]: changed = [] } = that && that.state[`changedValues${fieldsetName}`] || {}
	const idArr = [...added, ...deleted, ...changed]

	return idArr.length > 0
}


/**
 * 复现Grid中record.data（已合并所有嵌套list(含-added等)的数据）为一个新的changeValues数据(所有listValue均为-added)，可用于Form中changedValues或addListItem
 * @param {*} data 
 */
export const cloneListItem = data => {
	const doClone = data => {
		delete data.id
		const subLists = {}
		// 所有子类数据(形如 ffff[i].sub=v) 生成subLists{ffff:{i:{sub:v}}}
		Object.entries(data).forEach(([key, value]) => {
			if (!key.includes('['))
				return
			const fieldName = key.substring(0, key.indexOf('['))
			const m = matchListItem(fieldName, key)
			if (!m)
				return

			const { id, field } = m.groups
			const subList = subLists[fieldName] = subLists[fieldName] || {}
			const subItem = subList[id] = subList[id] || {}
			subItem[field] = value
			delete data[key]
		})

		Object.entries(subLists).forEach(([field, obj]) => {
			// 删除data['ffff']
			data[field] && data[field].forEach(id => obj[id] = obj[id] || {})
			delete data[field]
			const added = []
			let newId = 0
			Object.values(obj).forEach(subData => {
				subData = doClone(subData)
				added.push(--newId)
				const fieldPre = `${field}[${newId}].`
				data[`${fieldPre}id`] = newId
				Object.entries(subData).forEach(([key, value]) => data[`${fieldPre}${key}`] = value)
			})
			data[`${field}-added`] = added
		})

		return data
	}

	return doClone(_.cloneDeep(data))
}

/**
 * 把list转换成平铺数据对象
 * @param {*} listName 
 * @param {*} list 
 */
export const getListValuesFromList = (listName = '', list = [], ignore = []) => {
	const ret = {}
	ret[listName] = []
	list.filter(o => ignore.findIndex(id => id == o.id) === -1).forEach(item => {
		const id = item.id
		ret[listName].push(id)
		Object.entries(item).forEach(([key, value]) => ret[`${listName}[${id}].${key}`] = value)
	})

	return ret
}